function PredictiveSearch() {
    const searchInputDesktop = document.querySelector(".search-input");
    const predictiveSearchDesktop = document.querySelector(".predictive-search");
    const clearSearchDesktop = document.querySelector(".search-clear");
    const searchButtonDesktop = document.getElementById("search_button");
    const searchSectionDesktop = document.querySelector(".p-search-section");

    const searchInputMobile = document.querySelector(".search-input-mobile");
    const predictiveSearchMobile = document.querySelector(".predictive-search-mobile");
    const clearSearchMobile = document.querySelector(".search-clear-mobile");
    const searchButtonMobile = document.getElementById("m_search_button");
    const searchSectionMobile = document.querySelector(".p-search-section-mobile");

    const headerMenu = document.querySelector(".header-menu");
    let activeInput = null;

    const loadingSkeleton = `
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
        <div class="product"><div class="avatar"></div><div class="line"></div><div class="line"></div></div>
    `;

    function fetchSearchResults(query, type) {
        if (!query.trim()) {
            hideResults(type);
            return;
        }

        showLoading(type);
        const formEl = activeInput ? activeInput.closest("form") : null;
        let searchBase = "/search";
        if (formEl && formEl.getAttribute("action")) {
            searchBase = formEl.getAttribute("action");
        } else if (window.Shopify && Shopify.routes && Shopify.routes.root) {
            searchBase = Shopify.routes.root + "search";
        }
        const searchURL = `${searchBase}/suggest?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[type]=product,article,page&resources[options][unavailable_products]=hide&resources[options]=title,url,image&resources[limit]=6&resources[limit_scope]=each`;

        fetch(searchURL)
            .then(response => {
                if (!response.ok) throw new Error(response.status);
                return response.text();
            })
            .then(data => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const resultsHTML = doc.querySelector("#shopify-section-predictive-search").innerHTML;

                if (type === "mobile") {
                    predictiveSearchMobile.innerHTML = resultsHTML;
                } else {
                    predictiveSearchDesktop.innerHTML = resultsHTML;
                }
                showResults(type);
            })
            .catch(() => {
                hideResults(type);
            });
    }

    function showLoading(type) {
        if (type === "mobile") {
            predictiveSearchMobile.innerHTML = loadingSkeleton;
            predictiveSearchMobile.style.display = "block";
        } else {
            predictiveSearchDesktop.innerHTML = loadingSkeleton;
            predictiveSearchDesktop.style.display = "block";
        }
    }

    function showResults(type) {
        if (type === "mobile") {
            predictiveSearchMobile.style.display = "block";
            clearSearchMobile.style.display = "block";
        } else {
            predictiveSearchDesktop.style.display = "block";
            clearSearchDesktop.style.display = "block";
        }
    }

    function hideResults(type) {
        if (type === "mobile") {
            predictiveSearchMobile.style.display = "none";
            clearSearchMobile.style.display = "none";
            searchInputMobile.value = "";
        } else {
            predictiveSearchDesktop.style.display = "none";
            clearSearchDesktop.style.display = "none";
            searchInputDesktop.value = "";
        }
    }

    function debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    if (searchInputDesktop && window.innerWidth > 769) {
        activeInput = searchInputDesktop;
        searchInputDesktop.addEventListener("input", debounce(() => fetchSearchResults(activeInput.value, "desktop"), 300));
    }

    if (searchInputMobile && window.innerWidth < 769) {
        activeInput = searchInputMobile;
        searchInputMobile.addEventListener("input", debounce(() => fetchSearchResults(activeInput.value, "mobile"), 300));
    }

    if (clearSearchDesktop && window.innerWidth > 769) {
        clearSearchDesktop.addEventListener("click", () => hideResults("desktop"));
    }

    if (clearSearchMobile && window.innerWidth < 769) {
        clearSearchMobile.addEventListener("click", () => hideResults("mobile"));
    }

    if (searchButtonDesktop) {
        searchButtonDesktop.addEventListener("click", (e) => {
            e.stopPropagation();
            searchSectionDesktop.style.display = (searchSectionDesktop.style.display === "block") ? "none" : "block";
            if (searchSectionDesktop.style.display === "block") {
                activeInput.focus();
            }
        });
    }

    if (searchButtonMobile) {
        searchButtonMobile.addEventListener("click", (e) => {
            e.stopPropagation();
            searchSectionMobile.style.display = (searchSectionMobile.style.display === "block") ? "none" : "block";
            if (searchSectionMobile.style.display === "block") {
                headerMenu.classList.remove("show-menu");
                activeInput.focus();
            }
        });
    }

    document.addEventListener("click", (e) => {
        if (searchSectionDesktop && !searchSectionDesktop.contains(e.target) && e.target !== searchButtonDesktop && window.innerWidth > 769) {
            hideResults("desktop");
            searchSectionDesktop.style.display = "none";
        }
        if (searchSectionMobile && !searchSectionMobile.contains(e.target) && e.target !== searchButtonMobile && window.innerWidth < 769) {
            hideResults("mobile");
            searchSectionMobile.style.display = "none";
        }
    });
}

PredictiveSearch();